export const SSO = 'sso';
export const NEXT_ACCOUNT = 'nextAccount';
